import { i18n } from "@lingui/core";

export function getTranslation(object) {
    const languageCode = i18n.locale;


    if (languageCode && object && object[languageCode]) {
        return object[languageCode];
    }

    if (object && (object.defaultValue || object.defaultValue === "")) {
        return object.defaultValue;
    }

    if (!object) {
        return "";
    }

    console.error("unable to get translation for", object);
    return "";
}